import { render, staticRenderFns } from "./TagAdder.vue?vue&type=template&id=f3a263c2&scoped=true"
import script from "./TagAdder.vue?vue&type=script&lang=js"
export * from "./TagAdder.vue?vue&type=script&lang=js"
import style0 from "./TagAdder.vue?vue&type=style&index=0&id=f3a263c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a263c2",
  null
  
)

export default component.exports